/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Luci_Shopping_Api_Models_PickupOrderFulfillment } from './Luci_Shopping_Api_Models_PickupOrderFulfillment';
import type { Luci_Shopping_Api_Models_ShippingOrderFulfillment } from './Luci_Shopping_Api_Models_ShippingOrderFulfillment';
export type Luci_Shopping_Api_Models_OrderFulfillment = {
  method?: Luci_Shopping_Api_Models_OrderFulfillment.method;
  shipping?: Luci_Shopping_Api_Models_ShippingOrderFulfillment;
  pickup?: Luci_Shopping_Api_Models_PickupOrderFulfillment;
};
export namespace Luci_Shopping_Api_Models_OrderFulfillment {
  export enum method {
    POINT_OF_SALE = 'PointOfSale',
    SHIPPING = 'Shipping',
    PICKUP = 'Pickup',
  }
}

